import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

import HNSColors from "../../../../ui library/HNSColors";
import { SORT_OPTS } from "../../utils/strings";

const SortBy = ({ value, setSortValue }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleSelection(selectedValue) {
    setSortValue(selectedValue);
    handleClose();
  }

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="py-1 text-xs capitalize rounded-full"
        sx={{
          borderColor: HNSColors.secondary[500],
          color: HNSColors.secondary[500],
          "&:hover": { borderColor: HNSColors.secondary[400], color: HNSColors.secondary[400] },
        }}
        variant="outlined"
      >
        Sort by <KeyboardArrowDown className={`ml-2 transition-all ${open ? "rotate-180" : ""}`} />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
            marginTop: "8px",
          },
          "& .MuiList-root": {
            padding: 0,
            border: `1px solid ${HNSColors.secondary[500]}`,
            borderRadius: "8px",
          },
        }}
      >
        {SORT_OPTS.map((option, idx) => (
          <MenuItem
            key={option.value}
            className="text-sm"
            sx={{
              borderRadius:
                idx === 0 ? "8px 8px 0 0" : idx === SORT_OPTS.length - 1 ? "0 0 8px 8px" : "0",
              backgroundColor: option.value === value ? HNSColors.tertiary[900] : "transparent",
              "&:hover": { backgroundColor: HNSColors.tertiary[800] },
            }}
            onClick={() => handleSelection(option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SortBy;
